import React from 'react';
import cn from 'classnames';
import { string, element, bool } from 'prop-types';

import styles from './styles.module.scss';

const DEFAULT_TAG = 'h2';

function SectionTitle({
  children,
  tag: Tag,
  title,
  actions,
  icon,
  className,
  titleClassName,
  id,
  noSeparator,
  bigTitle,
  noLinesAtSides = false
}) {
  return (
    <div
      className={cn('middle section-title', className, {
        column: bigTitle,
        row: !bigTitle,
        [styles.isBigTitle]: bigTitle
      })}>
      {icon && <i className={`m-right-2 ${icon}`} />}
      <Tag
        {...(id && { id })}
        className={cn(styles.text, titleClassName, {
          'title-large': bigTitle,
          [styles.noLinesAtSides]: noLinesAtSides
        })}>
        {children || title}
      </Tag>
      {!noSeparator && <hr className={styles.titleSeparator} />}
      {actions}
    </div>
  );
}

SectionTitle.defaultProps = {
  className: '',
  tag: DEFAULT_TAG,
  titleClassName: ''
};

SectionTitle.propTypes = {
  actions: element,
  bigTitle: bool,
  className: string,
  icon: string,
  id: string,
  noLinesAtSides: bool,
  noSeparator: bool,
  tag: string,
  title: string,
  titleClassName: string
};

export default SectionTitle;
